import { Injectable } from '@angular/core';
import { HttpService } from '../../../shared/services/http/http-client.service';
import { environment } from '../../../../environments/environment';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class ListaVendasService {

  constructor(
    private http: HttpService
  ) { }

  retornaFornecedor(data: any, successHandle: Function, errorHandle: Function) {

    return this.http.doGet('/automaticReuse/industria/retornaFornecedoresReusoVenda/', data, successHandle, errorHandle);

  }
  inativarReuso(data: any, successHandle: Function, errorHandle: Function) {

    return this.http.doPost('/automaticReuse/industria/inativaReusoFornecedor/', data, successHandle, errorHandle);

  } 

}
